import { render, staticRenderFns } from "./XhsConf.vue?vue&type=template&id=dc6cfa46&scoped=true"
import script from "./XhsConf.vue?vue&type=script&lang=js"
export * from "./XhsConf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6cfa46",
  null
  
)

export default component.exports